import { useState, useEffect, useRef, useCallback } from "react"

import Grid from '@material-ui/core/Grid'
import AtividadeService from '@services/AtividadeService'
import ProcessoService from '@services/ProcessoService'
import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"
import TextField from '@base/Inputs/Text'
import Toast from '@base/Toast'
import SelectOption from '@base/Inputs/Select'
import ColaboradorService from '@services/ColaboradorService'
import useEmpresas from '@hooks/enums/useEmpresas';

export const ColaboradorDialog = (props) => {
	const [formNome,setFormNome] = useState("");
	const [formProcesso,setFormProcesso] = useState("");
	const [formProcessoId,setFormProcessoId] = useState("");
	const [formSobrenome,setFormSobrenome] = useState("");
	const [formEmail,setFormEmail] = useState("");
	const [formAtividade, setFormAtividade] = useState("");
	const [formEmpresa, setFormEmpresa] = useState("");

	const [listagemAtividade, setListagemAtividade] = useState([]);
	const listagemEmpresas = useEmpresas();
	

	const toastRef = useRef(null);

	const submit = () => {
		let obj = {
			nome : formNome,
			sobrenome : formSobrenome,
			email : formEmail,
			atividade: formAtividade,
			empresa: formEmpresa,
			processo: formProcessoId
		};

		if(formEmail === "") {
			toastRef.current.show("error", "O campo 'email' é obrigatório.");
		} else {
			props.handleLoading(true);
			ColaboradorService.adicionar(obj).then(caixa => {
				toastRef.current.show("success","Colaborador adicionado com sucesso!");

				props.aoSalvar(obj);
				limparFormulario();
			}).catch((error) => {
				const mensagens = error.response.data.mensagens;
				toastRef.current?.show("error", Array.isArray(mensagens) ? mensagens.join('<br/>') : "Ocorreu um erro ao salvar o colaborador.");
			}).finally(() => {
				props.handleLoading(false);
			});
		}
	}

	const limparFormulario = () => {
		setFormEmail("");
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}

	const carregarDados = useCallback(() => {

		if(props.id) {
			ColaboradorService.buscarPorId(props.id).then(resultado => {
				setFormNome(resultado.data.nome);
				setFormSobrenome(resultado.data.sobrenome);
				setFormEmail(resultado.data.email);
			}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar Colaborador!"));;
		}

		ProcessoService.buscarProcessoEmAndamento().then(resultado => {
			setFormProcesso(resultado.data.nome);
			setFormProcessoId(resultado.data.id);
		  });

		AtividadeService.listar().then(resposta => {

			setListagemAtividade(resposta.data.content.map(atividade => {
			  return {
				label : atividade.descricao,
				value : atividade.id
			  };
			}));
	
		  });

	}, [props]);

	useEffect(() => carregarDados(), [carregarDados]);
/*	<Grid container spacing={1}>
					<Grid item sm={6}>
						<TextField autoFocus label="Nome" value={formNome}  onChange={(e) => setFormNome(e.target.value)} />
					</Grid>
					<Grid item sm={6}>
						<TextField label="Sobrenome" value={formSobrenome}  onChange={(e) => setFormSobrenome(e.target.value)} />
					</Grid>
				</Grid>*/

	return (<>
		<Toast ref={toastRef} />
			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={props.aberto && (!props.loading)}
				title={props.id ? "Editar Colaborador" : "Cadastrar Colaborador "}
				actions={<ButtonSave onClick={submit} loading={props.loading} />}>


				<Grid container spacing={12}>
					<Grid item sm={12}>
						<TextField label="Processo" value={formProcesso} />
					</Grid>
				</Grid>

				<Grid container spacing={12}>
					<Grid item sm={12}>
						<TextField label="E-mail" value={formEmail}  onChange={(e) => setFormEmail(e.target.value)} />
					</Grid>
				</Grid>

				<Grid container spacing={12}>
					<Grid item sm={6}>
						<TextField label="Nome" value={formNome}  onChange={(e) => setFormNome(e.target.value)} />
					</Grid>
					<Grid item sm={6}>
						<TextField label="Sobrenome" value={formSobrenome}  onChange={(e) => setFormSobrenome(e.target.value)} />
					</Grid>
				</Grid>

				<Grid container spacing={12}>

					<Grid item sm={12} lg={12}>
						<SelectOption
						label='Atividade'
						value={formAtividade}
						name='formAtividade'
						onChange={(e) => setFormAtividade(e.target.value)}
						options={listagemAtividade} />
					</Grid>

				</Grid>

				<Grid container spacing={12}>

					<Grid item sm={12} lg={12}>
						<SelectOption
						label='Empresa'
						value={formEmpresa}
						name='formEmpresa'
						onChange={(e) => setFormEmpresa(e.target.value)}
						options={listagemEmpresas.data} />
					</Grid>

				</Grid>

			</Dialog>
		</>
	);
}

export default ColaboradorDialog;
